export default {
  theme: {
    dark: true,
    themes: {
      light: {
        primary: "#1976D2",
        secondary: "#9c9ca1",
        success: "#4CAF50",
        info: "#3F51B5",
        warning: "#FF9800",
        error: "#FF5252"
      },
      dark: {
        primary: "#1976D2",
        secondary: "#9c9ca1",
        success: "#4CAF50",
        info: "#3F51B5",
        warning: "#FF9800",
        error: "#FF5252"
      }
    }
  }
};
